import { Grid, Typography } from "@mui/material"
import Logo from "../../../../../../assets/img/white logo.svg"
import { ArrowComponent } from "../../../../../../components/arrow"
import { Constants, Format } from "../../../../../../utils"

export const Ruler = ({
    currentCredit = 1000
}: { currentCredit?: number }) => {

    const { creditEvolution } = Constants

    const index = creditEvolution.findIndex((item) => item === currentCredit)

    return (
        <Grid>
            <Grid
                sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    alignItems: "flex-end",
                    // mt: -6,
                    mb: "-14rem",
                    zIndex: 10,
                    position: "relative",
                }}
            >
                <Grid
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        flexWrap: "nowrap",
                        width: "35%"
                    }}
                >
                    <Typography fontSize={12} lineHeight={"16px"}>
                        <strong>Atual</strong> crédito<br />Pré-aprovado
                    </Typography>
                    <Typography variant="body2" color="secondary" fontWeight={700}>{Format.currencyWritten(currentCredit)}</Typography>
                    <ArrowComponent
                        sx={{
                            width: "90%"
                        }}
                        size={46}
                    />
                </Grid>

                <Grid
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        flexWrap: "nowrap",
                        width: "30%"
                    }}
                >
                    <Typography fontSize={12} lineHeight={"16px"}>
                        <strong>Próximo</strong> crédito<br />Pré-aprovado
                    </Typography>
                    <Typography variant="body2" color="secondary" fontWeight={700}>{Format.currencyWritten(creditEvolution[index + 1])}</Typography>
                    <ArrowComponent
                        sx={{
                            width: "90%"
                        }}
                        size={81}
                    />
                </Grid>

                <Grid
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        flexWrap: "nowrap",
                        width: "30%"
                    }}
                >
                    <Typography fontSize={12} lineHeight={"16px"}>
                        <strong>{index === 8 ? creditEvolution?.length - 1 : (index + 5) > creditEvolution?.length ? creditEvolution?.length : index + 5}º</strong> crédito<br />Pré-aprovado
                    </Typography>
                    <Typography variant="body2" color="secondary" fontWeight={700}>{Format.currencyWritten(creditEvolution[index === 8 ? creditEvolution?.length - 2 : (index + 5) > creditEvolution?.length ? creditEvolution?.length - 1 : index + 4])}</Typography>
                    <ArrowComponent
                        sx={{
                            width: "90%"
                        }}
                        size={108}
                    />
                </Grid>

                <Grid
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        flexWrap: "nowrap",
                        width: "40%",
                        mr: -2
                    }}
                >
                    <Typography fontSize={12} lineHeight={"16px"}>
                        <strong>{creditEvolution.length}º</strong> crédito<br />Pré-aprovado
                    </Typography>
                    <Typography variant="body2" color="secondary" fontWeight={900} fontSize={"2rem"}>{Format.currencyWritten(creditEvolution[creditEvolution.length - 1])}</Typography>
                    <ArrowComponent
                        sx={{
                            width: "70%"
                        }}
                        size={162}
                    />
                </Grid>

            </Grid>
            <Grid
                sx={{
                    width: "100%",
                    height: "15rem",
                    borderRadius: "10px",
                    background: "linear-gradient(90deg, #FE7B01 0%, #F1DF17 0.01%, #178BF1 51.4%, #1D22E6 100%)",
                    clipPath: "polygon(0% 100%, 0% 75%, 100% -2.5%, 100% 100%)",

                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                    zIndex: 9,
                    position: "relative",
                }}
            >
                <img
                    src={Logo}
                    alt="logo"
                    style={{
                        width: "6.2rem",
                        height: "2.8rem",
                        opacity: 0.2
                    }}
                />
            </Grid>
        </Grid>
    )
}